(ns practitest.frontend.components2.resize-panel
  (:require ["react-resizable-panels" :refer [PanelGroup Panel PanelResizeHandle]]))

(defn panel-resize-handle
  ([] (panel-resize-handle nil))
  ([{:keys [class]}]
   [:> PanelResizeHandle
    {:className (cond-> "resize-handle-outer"
                  class (str " " class))}
    [:div {:class "resize-handle-inner"}]]))

(defn panel-group [{:keys [auto-save-id direction] :or {direction "horizontal"}} & children]
  (into [:> PanelGroup {:direction direction
                        :autoSaveId auto-save-id}]
        children))

(defn panel-resizeable [{:keys [default-size min-size class collapsible collapsed-size panel-ref]
                         :or {default-size 50 min-size 50}} & children]
  (let [props (cond-> {:defaultSize default-size
                       :minSize min-size
                       :className class}
                collapsible (assoc :collapsible true)
                (some? collapsed-size) (assoc :collapsedSize collapsed-size)
                panel-ref (assoc :ref panel-ref))]
    [:> Panel props (into [:<>] children)]))
